<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import ModalTrigger from "@/components/Interface/Modal/ModalTrigger.vue";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { CDN } from '@/models/cdn.ts'
import PlayerName from '@/components/Objects/PlayerName.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="CDN.spy(64,props.newsItem.contentData.spy.imageCode)"
    :toast-text="t('news.types.spyCyberAttackSuccess.title')"
  >
    <ModalTrigger type="spy" :data="{spyId: props.newsItem.contentData.spy.id}" >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="CDN.spy(512,props.newsItem.contentData.spy.imageCode)"
        :header="t('news.types.spyCyberAttackSuccess.title')"
      >
        <div>
          <span class="text-slate-300">{{ props.newsItem.contentData.spy.name }}</span> {{ t('news.types.spyCyberAttackSuccess.body') }} <PlayerName :player-id="props.newsItem.contentData.spy.targetPlayerId" />.
          <div v-if="props.newsItem.contentData.data.effect === 'science_interrupted'" class="pt-2">
            {{ t('news.types.spyCyberAttackSuccess.scienceInterrupted') }}
          </div>
          <div v-if="props.newsItem.contentData.data.effect === 'credits_stolen'" class="pt-2">
            {{ t('news.types.spyCyberAttackSuccess.creditsStolen') }}
          </div>
        </div>
      </NewsItemBaseStructure>
    </ModalTrigger>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>